// extracted by mini-css-extract-plugin
module.exports = {"text":"accessControl_text__2YZU9","centered":"accessControl_centered__2h-we"};